import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

const state = {
    baseURL: '',
    // car: JSON.parse(localStorage.getItem("car")) ? JSON.parse(localStorage.getItem("car")) : '',
};

export default new Vuex.Store({
    state,
    getters: { // 监听数据变化的
        // getStorage(state) { // 获取本地存储的信息
        //     if (!state.car) {
        //         state.car = JSON.parse(localStorage.getItem('car'))
        //     }
        //     return state.car
        // }
    },
    mutations: {
        // $_setCar(state, value) { // 设置存储car
        //     state.car = value;
        //     localStorage.setItem('car', JSON.stringify(value));
        // },
    },
    actions: {},
    modules: {}
});


// WEBPACK FOOTER //
// ./src/store/store.js